import type {
  TrainingParticipant,
  TrainingParticipantChapter,
} from "@repo/app-types/entities/trainingParticipant";
import type { FC } from "react";
import { AssessmentCellChapterScore } from "./assessmentCellChapterScore.js";

export interface AssessmentCellProps {
  participant: TrainingParticipant;
  onParticipantAction: (
    participant: TrainingParticipant,
    chapter: TrainingParticipantChapter,
  ) => void;
}

export const AssessmentCell: FC<AssessmentCellProps> = (props) => {
  return (
    <div className="flex gap-2">
      {props.participant.course.chapters.map((chapter, chapterIndex) => (
        <AssessmentCellChapterScore
          key={chapter.id}
          chapterIndex={chapterIndex}
          chapter={chapter}
          assessment={props.participant?.assessment?.chapters[chapter.id]}
          onClick={() => props.onParticipantAction(props.participant, chapter)}
        />
      ))}
    </div>
  );
};
